// extracted by mini-css-extract-plugin
export var container = "about-us-module--container--UuYV7";
export var outerWrapper = "about-us-module--outer-wrapper--oV8ke";
export var section = "about-us-module--section--XgFmV";